import { InsuredPerson } from "./DlpFlow.interfaces";

export const isInsuredComplete = (insured: Partial<InsuredPerson>) =>
  Boolean(insured.dateOfBirth && insured.dateOfBirth.length === 10) &&
  Boolean(insured.firstName) &&
  Boolean(insured.isSmoking);
